"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalytics = void 0;
var GoogleAnalytics_1 = require("./GoogleAnalytics");
Object.defineProperty(exports, "GoogleAnalytics", { enumerable: true, get: function () { return GoogleAnalytics_1.GoogleAnalytics; } });
//# sourceMappingURL=index.js.map